import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import { Select } from 'reaxl-forms';
import EmailContext from '../EmailContext';
import EmailStaticContent from '../EmailStaticContent';
/**
 *  Use Chips or a Select as a Form input. Since Chips are not an official Form input, need to set inquiry selection
 *  variable here and bubble up to formData in EmailOwner
 */

const InquirySelections = /*#__PURE__*/memo(_ref => {
  let {
    inquirySelection = 'confirmAvailability',
    handleInquirySelection = () => {},
    hideTestDrive
  } = _ref;
  const {
    uiContext
  } = useContext(EmailContext);
  const {
    inquiry: inquiryConfig
  } = EmailStaticContent;
  if (uiContext !== 'default') {
    return null;
  }
  const inquiryKeys = ['confirmAvailability', 'information'];
  if (!hideTestDrive) inquiryKeys.push('scheduleTestDrive');
  inquiryKeys.push('vehicleHistory');
  return /*#__PURE__*/_jsx("div", {
    className: "marign-bottom-2 row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-12"
  }, void 0, /*#__PURE__*/_jsx(Select, {
    name: "inquiryDropdown",
    value: inquirySelection,
    options: inquiryKeys.map(key => ({
      label: inquiryConfig[key].label,
      value: key
    })),
    onChange: event => handleInquirySelection(null, event?.target?.value),
    label: "Subject",
    uiContext: "inside"
  })));
});
export default InquirySelections;